import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots'

import Modal from './Modal'
import LeadCapture from './LeadCapture'

const startChat = () =>
  // eslint-disable-next-line no-undef
  Verloop(function () {
    this.openWidget()
  })

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = { show: false }
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  showModal() {
    this.setState({ show: true })
  }

  hideModal() {
    this.setState({ show: false })
    if (this.props.isnew) {
      this.props.closeModal()
    }
  }

  render() {
    const { show } = this.state

    const {
      cta,
      heading,
      service,
      location,
      rental,
      equipment,
      isnew,
      isshow,
    } = this.props

    return (
      <>
        <Modal
          show={isnew ? isshow : show}
          ModalComponent={() => (
            <LeadCapture
              service={service}
              location={location}
              cta={cta}
              heading={heading}
              forRental={rental}
              forEquipment={equipment}
            />
          )}
          hideAction={this.hideModal}
        />
        {!isnew && (
          <div className={`is-cta-bottom  ${show && 'is-hidden'}`}>
            <div className="level is-mobile">
              <div className="level-item">
                <a href="tel:18001212323">
                  <FontAwesomeIcon
                    icon={faPhone}
                    color="teal"
                    className="menu-icon"
                    size="2x"
                    flip="horizontal"
                  />
                </a>
              </div>
              <div className="level-item">
                <a
                  onClick={this.showModal}
                  className="button is-medium btn-primary has-text-weight-bold is-solid"
                >
                  Book Now
                </a>
              </div>
              <div className="level-item">
                <a onClick={startChat}>
                  <FontAwesomeIcon
                    icon={faCommentDots}
                    color="teal"
                    className="menu-icon"
                    size="2x"
                  />
                </a>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}
